import script from "./CollectBuyTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectBuyTip.vue?vue&type=script&setup=true&lang=ts"

import "./CollectBuyTip.vue?vue&type=style&index=0&id=0531a2b4&lang=scss&scope=true"

const __exports__ = script;

export default __exports__